import { theme } from 'theme/App.theme';
import makeStyles from '@mui/styles/makeStyles';
import { appPalette } from 'theme/App.palette';
const { black, light_grey_4 } = appPalette.colors;

type Props = {
  navHeight: number;
};

export const useStyles = makeStyles({
  root: {
    padding: '0 1rem',
    [theme.breakpoints.up('viewportMedium')]: {
      '&.addMinHeight': {
        minHeight: '100vh',
      },
    },
  },
  headerContainer: {
    padding: '0 1rem',
  },
  header: {
    flexDirection: 'column',
    padding: '1.5625rem 0',
    '& h1': {
      [theme.breakpoints.up('viewportMedium')]: {
        marginBottom: '1rem',
      },
    },
    '& p': {
      color: light_grey_4,
    },
    [theme.breakpoints.up('viewportLarge')]: {
      width: '40%',
      padding: '3.125rem 0 3.75rem',
    },

    [theme.breakpoints.up('viewportXLarge')]: {
      width: '35%',
    },
  },
  searchContainer: {
    width: '100%',
  },
  zip_input_desktop: {
    display: 'none',
    [theme.breakpoints.up('viewportLarge')]: {
      display: 'block',
    },
  },
  tabContainer: {
    justifyContent: 'center',
  },
  showMoreButton: {
    width: '100%',
    '& div': {
      padding: '1rem 2.0625rem 0.75rem',
    },
    ...(theme.themeName === 'honda' && {
      color: 'white',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      height: '2.625rem',
      borderRadius: '0.3125rem',
      '& div': {
        padding: 0,
      },
    }),
  },
  noDealersText: {
    color: black,
    marginTop: '0.3125rem',
    padding: '0 1.25rem',
    textalign: 'left',
  },
  mapContainer: {
    height: '100vh',
    maxHeight: '93.75rem',
    padding: '0 0.9375rem',
  },
  dealersContainer: {
    [theme.breakpoints.up('viewportMedium')]: {
      padding: '0 0.5rem !important',
    },
    [theme.breakpoints.up('viewportLarge')]: {
      maxWidth: '42%',
      minWidth: '28.4375rem',
    },
  },
  dealerResultsContainer: {
    [theme.breakpoints.up('viewportMedium')]: {
      overflowY: 'scroll',
      maxHeight: '80vh',
      paddingRight: '0.375rem',
      marginBottom: '0.9375rem',
    },
  },
  mapDesktop: {
    height: (props: Props) => `calc(100vh - ${props.navHeight}px)`,
    maxHeight: '93.75rem',
    [theme.breakpoints.up('viewportLarge')]: {
      height: (props: Props) => `calc(100vh - ${props.navHeight}px)`,
      paddingLeft: '1.375rem',
    },
    [theme.breakpoints.up('viewportXLarge')]: {
      paddingLeft: '2rem',
    },
  },
  mapDesktopContainer: {
    position: 'relative',
    [theme.breakpoints.up('viewportMedium')]: {
      padding: '0 !important',
      '& .bottom': {
        position: 'absolute',
        top: 'unset',
        bottom: '0',
      },
    },
  },
  mapSkeleton: {
    height: '100vh',
    maxHeight: '93.75rem',
    margin: '0 auto',
    width: '100%',
    [theme.breakpoints.up('viewportMedium')]: {
      margin: '0',
      width: '100%',
      height: (props: Props) => `calc(100vh - ${props.navHeight}px)`,
    },
    [theme.breakpoints.up('viewportLarge')]: {
      margin: '0 auto',
      height: (props: Props) => `calc(100vh - ${props.navHeight}px)`,
    },
  },
  cardSkeleton: {
    width: '100%',
    height: '14.3125rem',
    margin: '0 auto',
    marginTop: '0.9375rem',
    '&:last-child': {
      marginBottom: '1.5625rem',
    },
    [theme.breakpoints.up('viewportMedium')]: {
      width: '100%',
      margin: '0',
      marginTop: '0.9375rem',
    },
  },
  showMoreSkeleton: {
    width: '100%',
    height: '3.125rem !important',
    margin: '0 auto',
    marginBottom: '0.625rem',
    marginTop: '1.25rem',
    [theme.breakpoints.up('viewportMedium')]: {
      width: '100%',
      marginTop: '1.25rem',
    },
  },
  filterSkeleton: {
    margin: '0 auto',
    marginBottom: '1.25rem',
    width: 'calc(100vw - 1.875rem)',
    height: '2.875rem !important',
    [theme.breakpoints.up('viewportMedium')]: {
      width: '100%',
    },
  },
  back_to_link_icon: {
    height: '0.75rem !important',
    width: '0.5rem  !important',
    marginLeft: '0.5rem',
    paddingTop: '0.0625rem',
  },
  body_shop_btn: {
    display: 'inline-flex',
  },
});
